export default __webpack_public_path__ + "static/marsdenpark-card-4cc518a8597738821765bdc0db29acf6.jpg";